import ClearIcon from '@mui/icons-material/Clear'
import { Box, Button, Collapse, FormControl, Grid, TextField, Typography } from '@mui/material'
import Snackbar from '@mui/material/Snackbar'
import React, { useEffect, useState, useContext } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import * as Types from '../../store/types/authTypes'
import ActionAlert from '../../theme/ActionAlert'
import { AuthContext } from '../../libs/contexts/authContext'

function ForgotPasswordPage(props) {
  const [username, setUsername] = useState('')
  const [showError, setShowError] = useState(false)
  const [open, setOpen] = useState(false)
  const { affiliateCode, productId } = useContext(AuthContext)

  const dispatch = useDispatch()

  let navigate = useNavigate()

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return
    }

    setShowError(false)
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    const query = new URLSearchParams(window.location.search)
    // let affiliateCode = query.get('affiliateCode')
    let data = {
      email: username,
      productId: productId ? parseInt(productId) : 81401,
    }

    props.sendForgotPasswordEmail(data)
  }

  useEffect(() => {
    const query = new URLSearchParams(window.location.search)
    let distributorId = query.get('userSourceCode')
    let data = {
      userSourceCode: distributorId,
    }
    props.getDistributorInfo(data)
  }, [])

  useEffect(() => {
    if (props.errorStatus === true) {
      setShowError(true)
      return () => {}
    }
    if (props.errorStatus === false) {
      setShowError(false)
      setOpen(true)
      let path = `/`
      goToPage(path)
      return () => {
        dispatch({ type: Types.FORGOT_PASSWORD_REQUEST })
      }
    }
  }, [props.errorStatus, navigate])

  function wait(time) {
    return new Promise((resolve) => {
      setTimeout(resolve, time)
    })
  }

  async function goToPage() {
    const query = new URLSearchParams(window.location.search)
    // let affiliateCode = query.get('affiliateCode')
    await wait(2000)
    navigate(`/?affiliateCode=${affiliateCode}`)
  }

  const action = (
    <Button onClick={handleClose} color="secondary" size="small">
      <ClearIcon />
    </Button>
  )

  return (
    <div className="background-image-login">
      {showError && (
        <div style={{ willChange: 'transform', marginTop: '80px' }}>
          <Collapse in={showError}>
            <ActionAlert
              onClick={() => {
                window.scrollTo(0, '0')
              }}
              onClose={() => {
                setShowError(false)
                window.scrollTo(0, '400')
              }}
              title="Email Address Incorrect"
              type="error"
            >
              We are not able to find your email address, please check the spelling and try again
            </ActionAlert>
          </Collapse>
        </div>
      )}
      {
        <Snackbar
          open={open}
          autoHideDuration={10000}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          sx={{
            '&.MuiSnackbar-anchorOriginTopRight': { top: '100px' },
          }}
          message="We've sent a password reset link to your email. Please check your inbox."
          action={action}
        />
      }

      <Grid
        container
        justifyContent="center"
        alignItems="center"
        flexGrow={1}
        sx={{ marginTop: { lg: '80px', md: '80px', sm: '40px', xs: '40px' } }}
      >
        <Box sx={homeStyle.main}>
          <Box sx={homeStyle.blueBox}>
            <Box sx={homeStyle.forgotPasswordTitle}>Forgot Password</Box>
            <Box sx={homeStyle.forgotPasswordSubtitle}>
              Please enter your email address. We will send you the instructions to create a new password.
            </Box>
            <Grid container spacing={2}>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <FormControl fullWidth>
                  <TextField
                    variant="outlined"
                    className="white-box"
                    id="outlined-email"
                    label="Email"
                    defaultValue="email@email.com"
                    placeholder="email@email.com"
                    fullWidth
                    onChange={(e) => setUsername(e.target.value)}
                    value={username}
                  />
                </FormControl>
              </Grid>

              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Button type="submit" sx={homeStyle.sendForgotPasswordButton} onClick={(e) => handleSubmit(e)}>
                  <Typography sx={homeStyle.sendEmailButtonText}>Send Email</Typography>
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Grid>
    </div>
  )
}
export default ForgotPasswordPage

const homeStyle = {
  sendEmailButtonText: {
    //color: "#FFFFFF",
    fontFamily: 'Roboto',
    fontStyle: 'bold',
    fontWeight: 800,
    textTransform: 'none',
    fontSize: '14px',
    lineHeight: '20px',
    textAlign: 'center',
    letterSpacing: '0.1px',
  },

  sendForgotPasswordButton: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',

    py: '10px',

    width: '100%',
    height: '40px',
    mt: '15px',
    backgroundColor: '#3C4FB9',
    color: 'white',
    borderRadius: '100px',
    flex: 'none',
    order: 2,
    flexGrow: 0,
    '&:hover': {
      backgroundColor: '#9BA5DF',
      color: '#36414E',
    },
    '&:disabled': {
      backgroundColor: '#C4CAF1',
      color: 'white',
      textTransform: 'none',
    },
  },
  forgotPasswordSubtitle: {
    width: { lg: '540px', md: '566px', xs: '311px' },
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '24px',
    textAlign: 'left',
    alignItems: 'center',
    color: '#56677B',
    flex: 'none',
    alignSelf: 'stretch',
    flexGrow: 0,
  },

  forgotPasswordTitle: {
    width: { lg: '740px', md: '666px', xs: '311px' },
    height: '32px',
    fontFamily: 'Roboto Slab',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: { lg: '36px', md: '36px', xs: '24px' },
    lineHeight: { lg: '44px', md: '44px', xs: '32px' },
    textAlign: 'center',
    color: '#003C4D',
    flex: 'none',

    flexGrow: 0,
  },
  blueBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    //alignSelf: "center",
    // justifyContent: "center",
    pt: { lg: '52px', md: '52px', sm: '39px', xs: '24px' },
    pr: { lg: '52px', md: '52px', sm: '39px', xs: '16px' },
    pb: { lg: '52px', md: '52px', sm: '39px', xs: '24px' },
    pl: { lg: '52px', md: '52px', sm: '39px', xs: '16px' },
    gap: { lg: '32px', md: '32px', sm: '32px', xs: '20px' },
    width: { lg: '544px', md: '570px', sm: '500px', xs: '300px' },
    height: { lg: '280px', md: '280px', sm: '280px', xs: '285px' },
    stretch: { height: '100%' },
    background: '#F5F7FF',
    borderRadius: '8px',
    flex: 'none',
    order: 1,
    alignSelf: 'center',
    flexGrow: 0,
  },
  main: {
    display: 'flex',
    flexDirection: 'column',
    alignSelf: 'center',
    alignItems: 'center',
    pt: { lg: '140px', md: '120px', sm: '110px', xs: '82px' },
    //pr: { lg: "407px", md: '32px', sm: "16px", xs: '16px' },
    pb: { lg: '80px', md: '40px', sm: '32px', xs: '32px' },
    // pl: { lg: "407px", md: '32px', sm: "px", xs: '16px' },
    gap: { lg: '40px', md: '32px', sm: '32px', xs: '20px' },
    width: { lg: '1000', md: '834', xs: '375' },
    height: { lg: '888', md: '1100', xs: '942' },
    background: '#FFFFFF',
    flex: 'none',
    order: 1,
    flexGrow: { lg: 1, md: 0, xs: 0 },
  },
  container: (theme) => ({
    display: 'flex',
  }),
  item: (theme) => ({
    border: '1px solid blue',
  }),
  itemFlexGrow: (theme) => ({
    flexGrow: 1,
    border: '1px solid red',
  }),
}
